import { useQuery } from '@tanstack/react-query';

import {
  fetchQuestsKratesMetadata,
  fetchQuestsSweepstakes,
} from '#/api/apiQuests';
import { minutes } from '#/api/queries/utils';

/**
 * Shared options of the questing API queries.
 * Values change roughly monthly, no need for aggressive refetching.
 * No fallback data - while loading and whenever the API call fails
 * (unreachable/down API, unexpected response structure, or CORS not allowing
 * perps origins) `data` stays undefined and consumers hide the values.
 */
const questsQueryOptions = {
  staleTime: minutes(60),
  // Keep retries low - when the API is unreachable there is no point
  // hammering it, consumers render without the values.
  retry: 1,
};

/** Krates (XP quests) metadata - price in XP */
export function useQuestsKratesMetadata() {
  return useQuery({
    queryKey: ['quests', 'kratesMetadata'],
    queryFn: fetchQuestsKratesMetadata,
    ...questsQueryOptions,
  });
}

/** Monthly sweepstakes - USD prize pool of the current month */
export function useQuestsSweepstakes() {
  return useQuery({
    queryKey: ['quests', 'sweepstakes'],
    queryFn: fetchQuestsSweepstakes,
    ...questsQueryOptions,
  });
}
